import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { PayloadsService } from './api/payloads.service';
import { PayloadsActions } from './payloads.actions';

export class PayloadsEffects {
  private readonly actions$ = inject(Actions);
  private readonly svc = inject(PayloadsService);

  getPayloads$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayloadsActions.getPayloads),
      switchMap(({ tenantUuid }) =>
        this.svc.getPayloads(tenantUuid).pipe(
          map((payloads) => PayloadsActions.getPayloadsSuccess({ payloads })),
          catchError((error) => of(PayloadsActions.getPayloadsFailure({ error }))),
        ),
      ),
    ),
  );
}
